var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{ref:"headerleads",staticClass:"header"},[_c('ApisCreationModal',{attrs:{"data-entity":"apis"},on:{"registered":_vm.emitNewApiRegistered}}),_c('button',{staticClass:"btn btn-primary btn-extra-round",on:{"click":_vm.openApiDocs}},[_vm._v("\n    "+_vm._s(_vm.$t('message.api.message.documentation'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }